module.exports = __webpack_public_path__ + "img/laboratorio_2022.22ee0115.jpg";